import { Box } from '@mui/material';
import React from 'react';

import GridLayout from 'layouts/GridLayout';

import CertificateInfo from './components/CertificateInfo';
import EditCertificateRequest from './components/EditCertificateRequest';

const ReviewCertificateStep = ({
  onBackStep,
  artworkFormState,
  artwork,
  listUploadedImages,
  mergedListImages,
}) => {
  return (
    <Box sx={{ pt: 3 }}>
      <GridLayout>
        <CertificateInfo
          artworkFormState={artworkFormState}
          artwork={artwork}
        />
        <EditCertificateRequest
          artwork={artwork}
          onBackStep={onBackStep}
          artworkFormState={artworkFormState}
          listUploadedImages={listUploadedImages}
          mergedListImages={mergedListImages}
        />
      </GridLayout>
    </Box>
  );
};

export default ReviewCertificateStep;
